import React, { useState } from 'react'
import classNames from 'classnames'
import { Dropdown, Form } from 'react-bootstrap'
import { CrossClientQueryClientQueryMode, CrossClientQueryClientQueryModes } from '../../../../models/CrossClient'
import { CLIENT_MODE_LABEL } from '../../utils'

interface CrossClientClientsPillProps {
  mode: CrossClientQueryClientQueryMode
  onChange: (mode: CrossClientQueryClientQueryMode) => void
  disabled?: boolean
}

export const CrossClientClientsPill: React.FC<CrossClientClientsPillProps> = ({ mode, onChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false)
  const includesShared = mode === CrossClientQueryClientQueryModes.WITH_SHARED
  const toggleShared = () => {
    onChange(includesShared ? CrossClientQueryClientQueryModes.ONLY_OWNED : CrossClientQueryClientQueryModes.WITH_SHARED)
  }

  return (
    <Dropdown autoClose='outside' onToggle={setIsOpen}>
      <Dropdown.Toggle as='button' bsPrefix='cross-client-pill' className='cross-client-pill d-flex gap-1 align-items-center' disabled={disabled}>
        <span className='paragraph-small bold'>Clients:</span>
        <span className='paragraph-small'>{CLIENT_MODE_LABEL[mode]}</span>
        {disabled ? null : <i className={classNames('bi paragraph-small zocks-text-gray-900', isOpen ? 'bi-chevron-contract' : 'bi-chevron-expand')} />}
      </Dropdown.Toggle>
      <Dropdown.Menu className='cross-client-popover'>
        <div className='paragraph-small'>
          Your clients are always included.
          <br />
          Add shared clients for more results?
        </div>
        <label className='d-flex align-items-center gap-2 cross-client-popover-row mb-0'>
          <Form.Check className='d-flex' type='checkbox' checked={includesShared} onChange={toggleShared} />
          <span className='paragraph-small'>Include shared clients</span>
        </label>
      </Dropdown.Menu>
    </Dropdown>
  )
}
